// Chrome lays boxes out in LayoutUnits of 1/64 CSS px (= 3/256 pt) and rounds
// every length to them; Yoga (react-pdf) computes in floats. Sums of lengths
// that are not on that grid therefore drift apart by a few hundredths of a
// point per block — about a quarter of a point down a full page. Both
// renderers snap every length to the grid first, so Chrome rounds nothing and
// the two engines add up exactly the same numbers.

export const GRID_PT = 3 / 256;

/** [v] (pt) snapped to Chrome's layout grid. */
export function snap(v: number): number {
  return Math.round(v / GRID_PT) * GRID_PT;
}

/** A CSS length for [v] (pt), snapped and written in exact CSS px. */
export function cssLength(v: number): string {
  const k = Math.round(v / GRID_PT);
  return k === 0 ? "0" : `${k / 64}px`;
}
